var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("v-col", { attrs: { cols: "4", xs: "4", md: "5" } }, [
    _c("div", { staticStyle: { "text-align": "center" } }, [
      _vm.showIndex ? _c("em", [_vm._v(_vm._s(_vm.index) + " ")]) : _vm._e(),
      _vm._v(" "),
      _c("br"),
      _vm._v(" " + _vm._s(_vm.name) + " "),
      _c("br"),
      _c("p", { staticStyle: { "font-size": "12px" } }, [
        _vm._v(_vm._s(_vm.startTime)),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }